import { useState } from "react";
import { BootstrapTooltip } from "../mui/BootstrapTooltip";
import { IconButton } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function CopytoclipboardIcon(props: any) {
  const { item, sx = {}, style, className, color = "#2e80ec", iconSize = 20 } =
    props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleCopyToClipboard = () => {
    setTooltipOpen(true);
    navigator.clipboard.writeText(item);

    setTimeout(() => {
      setTooltipOpen(false);
    }, 2000);
  };

  return (
    <BootstrapTooltip
      title="Copied to clipboard"
      open={tooltipOpen}
      disableFocusListener
      disableHoverListener
      placement="top"
      arrow
      disableTouchListener
    >
      <IconButton
        color="primary"
        sx={sx}
        style={style}
        className={className}
        aria-label="directions"
        onClick={handleCopyToClipboard}
      >
        <ContentCopyIcon style={{ fontSize: iconSize, color: color }} />
      </IconButton>
    </BootstrapTooltip>
  );
}
